import React from "react";
import _ from "lodash";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../../redux/actions/menuActions";
import { connect } from "react-redux";
import Redirect from "react-router/Redirect";
import { withRouter } from "react-router-dom";
import useWindowDimensions from "../../../components/window/dimensions";

const PowerBi = props => {
  let srcs = {
    3: "https://app.powerbi.com/reportEmbed?reportId=ed0a967b-759c-46df-88f1-91dae1f7d659&autoAuth=true&ctid=80534926-8493-4ede-be6a-ed1707a835e8&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWV1cm9wZS1ub3J0aC1iLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9",
    //17: "https://app.powerbi.com/reportEmbed?reportId=af323a0e-e448-4fd6-a2ce-1869afdb7813&autoAuth=true&ctid=80534926-8493-4ede-be6a-ed1707a835e8&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWV1cm9wZS1ub3J0aC1iLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9",
    17: "https://app.powerbi.com/reportEmbed?reportId=cda34585-3989-47a5-a3b7-51582d9ebdbc&autoAuth=true&ctid=80534926-8493-4ede-be6a-ed1707a835e8&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWV1cm9wZS1ub3J0aC1iLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9",
    11: "https://app.powerbi.com/reportEmbed?reportId=cac5dcb1-3a6b-4dc4-9bcd-c69ba880dfd1&autoAuth=true&ctid=80534926-8493-4ede-be6a-ed1707a835e8&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWV1cm9wZS1ub3J0aC1iLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9",
    //3: "https://app.powerbi.com/reportEmbed?reportId=f597175f-896d-4184-ab87-e06acade7c5c&autoAuth=true&ctid=80534926-8493-4ede-be6a-ed1707a835e8&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWV1cm9wZS1ub3J0aC1iLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9",
    //3: "https://app.powerbi.com/reportEmbed?reportId=af323a0e-e448-4fd6-a2ce-1869afdb7813&autoAuth=true&ctid=80534926-8493-4ede-be6a-ed1707a835e8&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWV1cm9wZS1ub3J0aC1iLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9",
  };
  if (props.currentClientId !== 17) {
  }
  const { height, width } = useWindowDimensions();
  if (!srcs[props.currentClientId]) {
    return (
      <Redirect
        push
        to={{
          pathname: `/` //state.state correspond à la visite sélectionnée
        }}
      />
    );
  }
  return (
    <iframe
      style={{ height: height - 140, width: width - 60, marginTop: -30, marginRight: 30, marginBottom: 10 }}
      //src="https://app.powerbi.com/reportEmbed?reportId=cda34585-3989-47a5-a3b7-51582d9ebdbc&autoAuth=true&ctid=80534926-8493-4ede-be6a-ed1707a835e8&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLWV1cm9wZS1ub3J0aC1iLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9"
      src={srcs[props.currentClientId]}
      frameBorder="0"
      allowFullScreen="true"
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  const currentClient = state.currentClient || {};
  const currentClientId = currentClient.id || 0;
  const currentUser = state.userInfos || {};
  const currentUserClients = currentUser.clients || [];
  const currentUserClient = _.find(currentUserClients, { id: currentClientId }) || {};
  const currentUserClientServices = currentUserClient.services || [];

  return {
    currentServices: currentUserClientServices,
    currentRoleId: currentUser.role_id || 100,
    currentClientId
  };
};

export default connect(
  mapStateToProps,
  null
)(withRouter(PowerBi));



// WEBPACK FOOTER //
// src/pages/admin/poc/PowerBi.js